module.exports = __webpack_public_path__ + "img/Stab_S6.72a3d4d5.svg";